import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";
import { AppState } from "../app.state";
import { EventSystemComplete } from "../../models/event-systems/event-system-complete.model";
import { EventComplete } from "../../models/events/event-complete.model";
import { UserComplete } from "../../models/account/user-complete.model";
import { PageContent } from "../../models/page-content.model";
import { EventHostComplete } from "../../models/event-hosts/event-host-complete.model";
import { combineReducers, createReducer } from "@ngrx/store";
import { userReducer } from "./user.reducer";
import { UserComponent } from "../../../user/feature/user.component";
import { EventDetailed } from "../../models/events/event-detailed.model";
import { eventsReducer } from "./events.reducer";
import { coreReducer } from "./core.reducers";
import { eventSystemReducer } from "./event-systems.reducer";
import { pagesReducer } from "./pages.reducers";
import { adminReducer } from "./admin.reducer";

export const appAdapter: EntityAdapter<AppState> = createEntityAdapter<AppState>();

export const appStoreReducer = combineReducers({
    user: userReducer,
    upcomingEvents : eventsReducer,
    core: coreReducer,
    eventSystems: eventSystemReducer,
    pages: pagesReducer,
    admin: adminReducer
})